import React, { useEffect, useState, useMemo } from 'react';
import { Observer } from 'mobx-react';
import { useParams, useHistory } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import TranCatForm from '../TranCatForm';

const TransactionCategoryInfo = () => {
  return (
    <Observer
      render={() => {
        const { tranCategoryId } = useParams();
        const history = useHistory();
        const { authStore, dataStore, orgStore } = useRootStore();
        const [isLoading, setLoading] = useState(true);
        const [transactionCategory, setTransactionCategory] = useState(null);
        const [dLink, setDLink] = useState('#');

        const accounts = dataStore.accountArray;
        const { settings } = orgStore;
        const { ExtSysId } = settings;

        const fetchTransactionCategory = async () => {
          try {
            const { data } = await authStore.request.get(
              `${process.env.REACT_APP_API}/api/transaction-category/${tranCategoryId}`,
            );
            setTransactionCategory(data);
          } catch (e) {
            console.error(e);
          }
        };

        const fetchTransactionCategoryDLink = async () => {
          try {
            const { data } = await authStore.request.get(
              `${process.env.REACT_APP_API}/api/trancat-xero-deeplink/${tranCategoryId}`,
            );
            setDLink(`https://go.xero.com/Accounts/Inventory/${data.ObjectId}`);
          } catch (e) {
            console.error(e);
          }
        };
        useEffect(() => {
          const initialActions = async () => {
            const requests = [];
            if (accounts.length === 0) {
              requests.push(dataStore.retrieveAccounts());
            }
            requests.push(fetchTransactionCategory());
            if (ExtSysId > 0) {
              requests.push(fetchTransactionCategoryDLink());
            }
            await Promise.all(requests);
            setLoading(false);
          };
          initialActions();
        }, []);

        if (isLoading || !transactionCategory) return <Spinner />;
        return (
          <FlexDiv>
            <WideBox>
              <TranCatForm
                deepLink={dLink}
                transactionCategory={transactionCategory}
                onSubmit={async (values, actions) => {
                  try {
                    Object.keys(values).forEach(key => {
                      if (values[key] === '' || values[key] === 'null') {
                        values[key] = null;
                      }
                    });
                    await authStore.request.post(
                      `${process.env.REACT_APP_API}/api/transaction-categories/`,
                      {
                        ...values,
                      },
                    );
                    await dataStore.retrieveTransactionCategories();
                    history.push('/transaction-categories');
                  } catch (e) {
                    console.error(e);
                    actions.setSubmitting(false);
                  }
                }}
              />
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default TransactionCategoryInfo;
